require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./context"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./context"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./context")) : factory(root["./utils"], root["./context"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__24__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[75],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(616);


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _withDragLayer = _interopRequireDefault(__webpack_require__(617));

exports.withDragLayer = _withDragLayer["default"];
exports["default"] = _withDragLayer["default"];

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = withDragLayer;
exports.DragLayer = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _reactDnd = __webpack_require__(26);

var _context = __webpack_require__(24);

var _utils = __webpack_require__(4);

var _dec, _class, _class2, _temp;

var omit = _utils.lodash.omit;
var DragLayer = (_dec = (0, _reactDnd.DragLayer)(function (monitor) {
  return {
    item: monitor.getItem(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
    canDrop: function canDrop() {
      return monitor.isDragging() && monitor.getTargetIds().some(function (targetId) {
        return monitor.isOverTarget(targetId) && monitor.canDropOnTarget(targetId);
      });
    }
  };
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DragLayer, _Component);

  function DragLayer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = DragLayer.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isDragging && !this.props.isDragging) {
      nextProps.onBeginDrag();
    } else if (!nextProps.isDragging && this.props.isDragging) {
      nextProps.onEndDrag();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        currentOffset = _this$props.currentOffset,
        item = _this$props.item,
        isDragging = _this$props.isDragging,
        canDrop = _this$props.canDrop;

    if (!currentOffset || !item || !isDragging || !item.dragLayerRenderer) {
      return null;
    }

    return item.dragLayerRenderer({
      itemProps: item,
      droppable: canDrop(),
      currentOffset: currentOffset
    });
  };

  return DragLayer;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  item: _propTypes["default"].object,
  isDragging: _propTypes["default"].bool.isRequired,
  currentOffset: _propTypes["default"].object,
  onBeginDrag: _propTypes["default"].func.isRequired,
  onEndDrag: _propTypes["default"].func.isRequired,
  canDrop: _propTypes["default"].func.isRequired
}), _temp)) || _class);
exports.DragLayer = DragLayer;

function withDragLayer(WrappedComponent) {
  var _dec2, _class3, _class4, _temp2;

  var WithDragLayer = (_dec2 = (0, _context.withContext)('theme'), _dec2(_class3 = (_temp2 = _class4 = /*#__PURE__*/function (_Component2) {
    (0, _inheritsLoose2["default"])(WithDragLayer, _Component2);

    function WithDragLayer() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component2.call.apply(_Component2, [this].concat(args)) || this;
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBeginDrag", function () {
        _this._dragLayerContainer.hidden = false;
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onEndDrag", function () {
        _this._dragLayerContainer.hidden = true;
      });
      return _this;
    }

    var _proto2 = WithDragLayer.prototype;

    _proto2.componentWillMount = function componentWillMount() {
      var dragLayerContainer = document.createElement('div');
      dragLayerContainer.hidden = true;
      document.body.appendChild(dragLayerContainer);
      this._dragLayerContainer = dragLayerContainer;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this._dragLayerContainer) {
        _reactDom["default"].unmountComponentAtNode(this._dragLayerContainer);

        this._dragLayerContainer.parentNode.removeChild(this._dragLayerContainer);

        this._dragLayerContainer = null;
      }
    };

    _proto2.render = function render() {
      var _this$props2 = this.props,
          dragLayerForwardRef = _this$props2.dragLayerForwardRef,
          other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["dragLayerForwardRef"]);
      var passThroughProps = omit(other, 'theme');
      return [/*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
        key: "0"
      }, passThroughProps, {
        ref: dragLayerForwardRef
      })), _reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(DragLayer, {
        onBeginDrag: this._onBeginDrag,
        onEndDrag: this._onEndDrag
      }), this._dragLayerContainer)];
    };

    return WithDragLayer;
  }(_react.Component), (0, _defineProperty2["default"])(_class4, "propTypes", {
    theme: _propTypes["default"].string,
    dragLayerForwardRef: _propTypes["default"].any
  }), _temp2)) || _class3);
  return _react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WithDragLayer, (0, _extends2["default"])({}, props, {
      dragLayerForwardRef: ref
    }));
  });
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[615,0]]]);
});